<template>
  <div id="app">
    <mdb-navbar position="top" color="light-blue" dark transparent scrolling>
      <mdb-container>
        <mdb-navbar-brand>
          <a @click="scrollToId(false)"> 
            <img src="./assets/name_signaturesize.png" style="height:40px;"/>
            </a>
        </mdb-navbar-brand>
        <mdb-navbar-toggler style="max-width: 1140px">
          <mdb-navbar-nav left>
            <mdb-nav-item waves-fixed active @click="scrollToId(false)">Accueil</mdb-nav-item>
            <mdb-nav-item waves-fixed @click="scrollToId('team')">Equipe</mdb-nav-item>
            <mdb-nav-item waves-fixed @click="scrollToId('contact')">Contact</mdb-nav-item>
          </mdb-navbar-nav>
        </mdb-navbar-toggler>
      </mdb-container>
    </mdb-navbar>
    <router-view />
  </div>
</template>
<script>
import {
  mdbNavbar,
  mdbNavbarBrand,
  mdbNavbarToggler,
  mdbNavbarNav,
  mdbNavItem,
  mdbContainer,
} from "mdbvue";
export default {
  name: "Intro",
  components: {
    mdbNavbar,
    mdbNavbarBrand,
    mdbNavbarToggler,
    mdbNavbarNav,
    mdbNavItem,
    mdbContainer,
  },
  methods: {
    scrollToId: function (id) {
      let top = 0;
      if(id) top = document.getElementById(id).offsetTop - 100;
      window.scrollTo({
        top: top,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap");

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
}
.top-nav-collapse {
  background-color: #82b1ff !important;
}
</style>
